export const objectDefault = {
  // flota_id: 4,
  flota_nombre: "",
  flota_user: "",
  flota_empresa: "",
  flota_fecreg: "",
};

export const columns = [
  {
    id: "flota_nombre",
    label: "Nombre",
    minWidth: 25,
    tipo: "string",
    propiedad: "flota_nombre",
  },
  {
    id: "flota_user",
    label: "User",
    minWidth: 25,
    tipo: "string",
    propiedad: "flota_user",
  },
  {
    id: "flota_fecreg",
    label: "Fec. Reg.",
    minWidth: 25,
    tipo: "string",
    propiedad: "flota_fecreg",
  },
];
